import { useSelector } from 'react-redux';
import { Modal } from '@pmi/dsm-react';
import { accountSelector } from '../../../shared/store/shared/accountSlice';
import { useRemoveLogoMutation } from './apiSlice';
import styles from './logoRemoveModal.module.scss';
import { toastWithAnalytics } from '../../../shared/analytics';

interface LogoRemoveModalProps {
  onCancel?: () => void;
  onSuccess?: () => void;
}

export default function LogoRemoveModal({
  onCancel = () => {},
  onSuccess = () => {},
}: LogoRemoveModalProps) {
  const { currentAccountId } = useSelector(accountSelector);
  const [removeLogo] = useRemoveLogoMutation();
  const onRemove = async () => {
    removeLogo(currentAccountId)
      .unwrap()
      .then(() => {
        toastWithAnalytics('Your logo was removed successfully', 'success');
        onSuccess();
        onCancel();
      })
      .catch(() => {
        toastWithAnalytics('There was an error removing your logo', 'danger');
      });
  };
  const onCancelHandler = () => {
    onCancel();
  };

  return (
    <Modal
      show
      onClose={onCancelHandler}
      headline="Remove?"
      description=""
      customClassName={`${styles['remove-logo-modal']}`}
      headline_description="Are you sure you want to remove this logo? This action cannot be undone."
      buttons={[
        {
          titleText: 'Cancel',
          variant: 'outline-secondary',
          onClick: onCancelHandler,
        },
        {
          titleText: 'Yes, Remove',
          variant: 'primary',
          onClick: onRemove,
        },
      ]}
    />
  );
}
